/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuButton, NeuIcon } from '@neutron/react';

import './ConfirmToast.styles.scss';

interface IConfirmToastProps {
  msg: string;
  icon: boolean;
  warning?: string | null;
  confirmText: string;
  confirmColor?: 'blue' | 'red' | 'orange' | null;
  closeText: string;
  confirm: () => void;
  handleClose: () => void;
}

const ConfirmToast: FC<IConfirmToastProps> = ({
  msg,
  icon,
  warning,
  confirmText = 'Yes',
  confirmColor,
  closeText = 'No',
  confirm,
  handleClose
}) => (
  <>
    <span
      className="d-flex flex-column w-100 mb-2 text-center toast-text toast-text-bold"
      color="primary"
    >
      {icon && (
        <NeuIcon className="mx-auto mb-2" color="blue">
          info
        </NeuIcon>
      )}
      {msg}
    </span>
    <span className="neu-text-plain-100 w-100 my-2 text-center toast-text toast-text-small confirm-toast__warning">
      {warning}
    </span>
    <div className="d-flex flex-row justify-content-between w-100 p-0">
      <NeuButton
        className="confirm-toast__button"
        aria-label="close toast"
        color="orange"
        kind="secondary"
        size="small"
        onClick={() => handleClose()}
      >
        {closeText}
      </NeuButton>
      <NeuButton
        className="confirm-toast__button"
        color={confirmColor ?? 'blue'}
        kind="primary"
        size="small"
        onClick={() => confirm()}
      >
        {confirmText}
      </NeuButton>
    </div>
  </>
);

export default ConfirmToast;
